module.exports = __webpack_public_path__ + "img/ClickForSound_31.17d9c052.png";